export default "__VITE_ASSET__tkxbSOBV__"